import {
  FormikSharedConfig,
  FormikState,
  FormikActions,
  FormikHandlers,
  FormikComputedProps,
  FormikRegistration
} from 'formik';
import { CreateOrUpdateUserApplicationMutationVariables } from 'interfaces/graphql-typings';

export enum ApplicantTypes {
  pro = 'pro',
  basic = 'basic'
}

export enum InvestorEmploymentTypes {
  employed = 'Employed',
  seekingEmployment = 'Seeking Employment',
  student = 'Student'
}

export enum InvestorTypes {
  buyside = 'Buyside',
  allocator = 'Allocator'
}

export type ApplicationFormValues = Partial<CreateOrUpdateUserApplicationMutationVariables>;

export type AllFormikProps = FormikSharedConfig &
  FormikState<ApplicationFormValues> &
  FormikActions<ApplicationFormValues> &
  FormikHandlers &
  FormikComputedProps<ApplicationFormValues> &
  FormikRegistration;
